import type { SocialAccount } from '../types/social-account'

export const primarySocials: SocialAccount[] = [
  {
    icon: 'heroicons-solid:mail',
    url: 'jairodrigues99@gmail.com',
    label: 'Email',
    username: 'jairodrigues99@gmail.com',
  },
  {
    icon: 'fa-brands:telegram',
    url: 'https://t.me/jairodrigues',
    label: 'Telegram',
    username: 'jairodrigues',
  },

  {
    icon: 'fa-brands:whatsapp',
    url: 'https://wa.me/+5581981579303',
    label: 'WhatsApp',
    username: '+55 81 98157-9303',
  },
  {
    icon: 'fa-brands:linkedin',
    url: 'https://www.linkedin.com/in/jairodrigues/',
    label: 'LinkedIn',
    username: '@jairodrigues',
  },
  {
    icon: 'fa-brands:github',
    url: 'https://github.com/JairRodrigue',
    label: 'GitHub',
    username: '@JairRodrigue',
  },
  {
    icon: 'fa-brands:instagram',
    url: 'https://www.instagram.com/jair.arauj/',
    label: 'Instagram',
    username: '@jair.arauj',
  },
]

export const homeSocials: SocialAccount[] = [
  {
    icon: 'heroicons-solid:mail',
    url: 'jairodrigues99@gmail.com',
    label: 'Email',
    username: 'jairodrigues99@gmail.com',
  },
  {
    icon: 'fa-brands:telegram',
    url: 'https://t.me/jairodrigues',
    label: 'Telegram',
    username: 'jairodrigues',
  },
  {
    icon: 'fa-brands:whatsapp',
    url: 'https://wa.me/+5581981579303',
    label: 'WhatsApp',
    username: '+55 81 98157-9303',
  },
  {
    icon: 'fa-brands:linkedin',
    url: 'https://www.linkedin.com/in/jairodrigues/',
    label: 'LinkedIn',
    username: '@jairodrigues',
  },
  {
    icon: 'fa-brands:github',
    url: 'https://github.com/JairRodrigue',
    label: 'GitHub',
    username: '@JairRodrigue',
  },
  {
    icon: 'fa-brands:instagram',
    url: 'https://www.instagram.com/jair.arauj/',
    label: 'Instagram',
    username: '@jair.arauj',
  },
]

const allSocials = [...homeSocials]

export default allSocials
